import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MetaTags from '../../components/common/layouts/MetaTags';
import ExploreIndexPage from '../../components/explore/index/ExploreIndexPage';
import ExploreMerchant from '../../domain/entities/ExploreMerchant';
import MerchantCategory from '../../domain/entities/MerchantCategory';
import implExploreRepository from '../../infrastructure/repositories/ExploreRepository';
import implCategoryRepository from '../../infrastructure/repositories/MerchantCategoryRepository';
import actions from '../../redux/actions/explore';
import { State } from '../../redux/reducers/explore';

export interface ReduxProps {
  actions: {
    searchAreas: (query: string, merchantCategoryId: number) => void;
    searchCategories: () => void;
  };
  explore: State;
}

export interface PageProps {
  primaryCategories: MerchantCategory[];
  popularMerchants: ExploreMerchant[];
  recentlyBookedMerchants: ExploreMerchant[];
  newMerchants: ExploreMerchant[];
  categories: MerchantCategory[];
}

type Props = PageProps & ReduxProps;

/**
 * Page Component
 */
class ExploreIndex extends React.PureComponent<Props> {
  constructor(props: Props) {
    props.actions.searchCategories();

    super(props);
  }

  public static async getInitialProps(_: {}): Promise<PageProps> {
    const exploreTopContent = implExploreRepository.TopContent();
    const categories = implCategoryRepository.Search();

    return Promise.all([exploreTopContent, categories]).then(results => {
      const newProps: PageProps = {
        newMerchants: results[0].newMerchants,
        popularMerchants: results[0].popularMerchants,
        recentlyBookedMerchants: results[0].recentlyBookedMerchants,
        categories: results[1],
        primaryCategories: results[0].primaryCategories,
      };

      return newProps;
    });
  }

  public render() {
    return (
      <>
        <MetaTags />
        <ExploreIndexPage {...this.props} />
      </>
    );
  }
}

export default connect(
  // tslint:disable-next-line: no-any
  ({ explore }: any) => ({ explore }),
  dispatch => ({
    actions: {
      searchAreas: bindActionCreators(actions.searchAreas, dispatch),
      searchCategories: bindActionCreators(actions.searchCategories, dispatch),
    },
  }),
)(ExploreIndex);
